import { FC } from 'react';

import { IconProps } from '../types';

const DermatologicallyTestedIcon: FC<IconProps> = ({ size, ...props }) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    {...props}
    aria-hidden="true"
  >
    <path
      d="M25.2097 27.9697L25.8218 35.6828L20.3125 33.9028L14.8032 35.6828L15.4154 27.9697"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.3125 24.1133C24.2681 24.1133 27.4746 20.9067 27.4746 16.9512C27.4746 12.9956 24.2681 9.78906 20.3125 9.78906C16.3569 9.78906 13.1504 12.9956 13.1504 16.9512C13.1504 20.9067 16.3569 24.1133 20.3125 24.1133Z"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.992 4.96695C19.2706 3.67768 21.3551 3.67768 22.6337 4.96695C23.3773 5.71661 24.4371 6.06098 25.4793 5.89152C27.2716 5.60008 28.958 6.82527 29.2347 8.61991C29.3955 9.66344 30.0505 10.565 30.9932 11.0405C32.6146 11.8582 33.2587 13.8405 32.4276 15.4551C31.9445 16.3939 31.9445 17.5083 32.4276 18.4471C33.2587 20.0616 32.6146 22.044 30.9932 22.8617C30.0505 23.3371 29.3955 24.2387 29.2347 25.2823C28.958 27.0769 27.2716 28.302 25.4793 28.0107C24.4371 27.8412 23.3773 28.1856 22.6337 28.9353C21.3551 30.2244 19.2706 30.2244 17.992 28.9353C17.2485 28.1856 16.1886 27.8412 15.1465 28.0107C13.3541 28.302 11.6678 27.0769 11.3911 25.2823C11.2302 24.2387 10.5752 23.3371 9.63249 22.8617C8.01119 22.044 7.36706 20.0616 8.19809 18.4471C8.68131 17.5083 8.68131 16.3939 8.19809 15.4551C7.36706 13.8405 8.01119 11.8582 9.63249 11.0405C10.5752 10.565 11.2302 9.66344 11.3911 8.61991C11.6678 6.82527 13.3541 5.60008 15.1465 5.89152C16.1886 6.06098 17.2485 5.71661 17.992 4.96695Z"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.8632 19.7058V14.1965H19.2104"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DermatologicallyTestedIcon;
